import { constructEnum } from '@/lib/enum';

const AiIconType = constructEnum('AiIconType', {
  GRADIENT: 10,
  CUSTOM: 20
});

export default AiIconType;
